import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x1Ee38d535d541c55C9dae27B12edf090C608E6Fb', // TODO
  // Deployed our own Multicall to the real, public BSC Testnet
  // (hardhat/scripts/deploy-multicall.ts) rather than relying on a third-party one.
  [ChainId.BSCTESTNET]: '0x9435F82bF5eFD9C6ff8326E5206B7b4686FEb0F1'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
